import React, {useState} from "react";
import styles from "./variantItem/VariantItem.module.scss";

const VariantItem = ({ data, handleOnHover, handleOnMouseLeave, handleSetSelectedVariants, active, themeColor }) => {

  const [isHover, setIsHover] = useState(false)

  return (
    <div
      onClick={() => handleSetSelectedVariants(data.id)}
      onMouseEnter={() => {
        handleOnHover(data.id)
        setIsHover(true)
      }}
      onMouseLeave={() => {
        handleOnMouseLeave()
        setIsHover(false)
      }}
      className={[styles.VariantItem, (active ? styles.active : ''), 'd-flex align-items-center justify-content-between'].join(' ')}
      style={{backgroundColor: active && themeColor, borderColor: isHover && themeColor}}
    >
      <div>
        <span>Variant { data.id }</span>
      </div>
      <div className={[styles.desc, 'd-flex align-items-center'].join(' ')}>
        <div>
          <span>{data.percentage}% | {data.count}</span>
        </div>
        <div className={[styles.icon, 'd-flex'].join(' ')}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.375 3.75L11.625 9L6.375 14.25" stroke="#0A195C" style={{stroke: !active && isHover && themeColor && themeColor}} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      {
        !active &&
          <span className={styles.progressBar} style={{width: `${data.percentage}%`}}></span>
      }
    </div>
  )
};

export default VariantItem;